import { z } from 'zod';
import i18n from '../../../i18n';

export const categoryFormSchema = z.object({
  id: z.string().optional(),
  name: z
    .string()
    .min(1, i18n.t('form.nameRequired', { ns: 'categories' }))
    .min(2, i18n.t('form.nameMinLength', { ns: 'categories' }))
    .max(50, i18n.t('form.nameMaxLength', { ns: 'categories' })),
  icon: z.string().min(1, i18n.t('form.iconRequired', { ns: 'categories' })),
  iconColor: z.string().nullish(),
  backgroundColor: z.string().nullish(),
  categoryGroupId: z.string().nullish(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
}).transform((data) => {
  const cleaned: Record<string, any> = {};
  Object.entries(data).forEach(([key, value]) => {
    if (value !== null) {
      cleaned[key] = value;
    }
  });
  return cleaned as typeof data;
});

export type CategoryFormData = z.infer<typeof categoryFormSchema>;

export const categoryGroupSchema = z.object({
  id: z.string().optional(),
  name: z
    .string()
    .min(1, i18n.t('form.nameRequired', { ns: 'categories' }))
    .min(2, i18n.t('form.nameMinLength', { ns: 'categories' }))
    .max(50, i18n.t('form.nameMaxLength', { ns: 'categories' })),
  icon: z.string().optional(),
  iconColor: z.string().nullish(),
  backgroundColor: z.string().nullish(),
  categoryGroupId: z.string().nullish(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
  categories: z.array(categoryFormSchema).min(1, i18n.t('form.atleastone', { ns: 'categories' }))
}).transform((data) => {
  const cleaned: Record<string, any> = {};
  Object.entries(data).forEach(([key, value]) => {
    if (value !== null) {
      cleaned[key] = value;
    }
  });
  return cleaned as typeof data;
});
export type CategoryGroupSchema = z.infer<typeof categoryGroupSchema>;
